import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    backdrop: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        ...shorthands.padding(tokens.spacingVerticalXXL),
    },
    card: {
        backgroundColor: tokens.colorNeutralBackground1,
        ...shorthands.borderRadius(tokens.borderRadiusXLarge),
        ...shorthands.padding(tokens.spacingVerticalXXXL, tokens.spacingHorizontalXXXL),
        boxShadow: tokens.shadow64,
        maxWidth: '500px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.gap(tokens.spacingVerticalXL),
    },
    title: {
        textAlign: 'center',
        color: tokens.colorNeutralForeground1,
    },
    message: {
        textAlign: 'center',
        color: tokens.colorNeutralForeground2,
        lineHeight: '1.5',
    },
    progressContainer: {
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.gap(tokens.spacingVerticalM),
        marginTop: tokens.spacingVerticalL,
    },
    progressBar: {
        width: '100%',
    },
    percentage: {
        textAlign: 'center',
        fontSize: tokens.fontSizeBase400,
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorBrandForeground1,
    },
    button: {
        marginTop: tokens.spacingVerticalL,
        alignSelf: 'center',
    },
});
